import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { AppContext } from '../../context/appContext';

const DocumentHead = () => {
  const [settings] = useContext(AppContext);
  return (
    <Helmet>
      <link href={settings.fontLink} rel="stylesheet" />
      {settings?.favicon && <link rel="icon" href={settings.favicon} />}
      <title>{settings.title || '#Érintésmentes'}</title>
    </Helmet>
  );
};

export default DocumentHead;
